// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__1tSnr","amount":"Amount_amount__AtlxV","tip":"Amount_tip__3my_2","tipHeader":"Amount_tipHeader__-3TJE","tipsWrap":"Amount_tipsWrap__3WxhD"};